import styles from '../styles.module.scss';
import skeleton from './styles.module.scss';
import UserPaymentDetailsFormContentUserKycCardStatus from '../Status';
import { KYCStatus } from '@starsoft/common/enums';

export default function UserPaymentDetailsFormContentUserKycCardSkeleton() {
  return (
    <div className={styles.card}>
      <div className={styles.card__row}>
        <div className={styles.card__row__wrapper}>
          <div className={styles.card__row__wrapper__column}>
            <div className={styles.card__row__wrapper__label}>
              <div className={skeleton.label} />
            </div>
            <div className={styles.card__row__wrapper__description}>
              <div className={skeleton.description} />
            </div>
          </div>
        </div>
        <UserPaymentDetailsFormContentUserKycCardStatus
          isLoading
          status={KYCStatus.Created}
        />
      </div>
    </div>
  );
}
